/*
 * Copyright (c) 2020.
 * This file is part of the Compo B2B application.
 * (c) Compo soft - Vladimir Ganturin <gun2rin@gmail.com>
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */

import {ChangeDetectionStrategy, Component, inject, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {BaseComponent} from 'compob2b-libs';
import {translations} from '../../../../environments/translations.ru'

@Component({
  selector: 'app-external-upload',
  templateUrl: './external-upload.component.html',
  styleUrls: ['./external-upload.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ExternalUploadComponent extends BaseComponent implements OnInit {
  title = '';
  externalUploadSyncUid: string;
  route = inject(ActivatedRoute);
  protected readonly translations = translations;

  ngOnInit(): void {
    this.externalUploadSyncUid = this.route.snapshot.paramMap.get('externalUploadSyncUid');
    this.compoApiService.get<string>('/dam/upload/' + this.externalUploadSyncUid).subscribe(response => {
      this.title = response.data;
      this.cdr.detectChanges();
    });
  }

  get uploadURI(): string {
    return '/dam/external-upload/' + this.externalUploadSyncUid;
  }
}
